import types from './types';
export default {
  [types.SET_LOADING](state, isLoading) {
    state.loading = isLoading;
  },
  setIsNavOpen(state, payload) {
    state.isNavOpen = payload.isNavOpen;

    if (payload.preserveOption)
      state.navOption = payload.navOption || state.navOption;
    else state.navOption = payload.navOption;
  },
  toggleNav(state) {
    state.isNavOpen = !state.isNavOpen;
  },
  setOpenCaseList(state, value) {
    state.isCaseListOpen = value;
  },
  setIsMobileDensity(state, value) {
    state.isMobileDensity = value;
  },
  setSidebarBadges(state, payload) {
    state.sidebarBadges = payload;
  },
  [types.SET_ITEM_MODEL](state, payload) {
    state.itemModel = payload;
  },

  //used for send state notification to the case info view for (refresh status case and show some additional data entry)
  setRefreshCaseInfo(state, payload) {
    state.lastNotifyRefreshCaseInfo = payload.lastNotify;
    state.lastNotifyRefreshCaseInfoType = payload.lastNotifyType;
    state.lastNotifyRefreshCaseInfoValue = payload.lastNotifyValue;
  },
  disposeCaseInfo(state) {
    state.lastNotifyRefreshCaseInfo = null;
    state.lastNotifyRefreshCaseInfoType = null;
    state.sidebarBadges = {};
    state.itemModel = {};
    state.isCaseListOpen = false;
  },
  setRefreshCaseList(state, payload) {
    state.lastRefreshCaseList = new Date();
    state.refreshCaseListPayload = payload;
  },
  [types.SET_BADGE_TOTAL](state, payload) {
    state.sidebarBadges = payload;
  },
  setFilterViewDetails(state, payload) {
    state.filterViewDetails = payload;
  },
  setFilterViewBySubType(state, payload) {
    state.filterBySubType = payload;
  },
  setAssignedRequests(state, payload) {
    state.assignedRequests = payload;
  },
  [types.SET_SITEMAP_INFO](state, payload) {
    state.sitemapInfo = payload;
  },
};
